__turbopack_context__.v({
  "container": "Header-module-scss-module__wS1-Va__container",
  "content": "Header-module-scss-module__wS1-Va__content",
  "logoAndLabel": "Header-module-scss-module__wS1-Va__logoAndLabel",
  "nonStickyWrapper": "Header-module-scss-module__wS1-Va__nonStickyWrapper",
  "sticky": "Header-module-scss-module__wS1-Va__sticky",
  "wrapper": "Header-module-scss-module__wS1-Va__wrapper",
});
